import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { overrideGlobalConsole } from './utils/logger';

// 根據環境變數覆蓋全局 console，避免在生產環境輸出 log
overrideGlobalConsole();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
